import { upperFirst } from 'lodash-es';

import {
  CompanyBilling,
  DashpivotModules,
  PlanTypeLimits,
  UserTypes,
} from '@site-mate/dashpivot-shared-library';
import { CompanyPlanTypes } from '@site-mate/sitemate-global-shared';

export const ToastMessages = {
  [UserTypes.Contributor]: {
    invite: 'contributorAdded',
    update: 'contributorPermissionUpdated',
    remove: 'contributorRemoved',
  },
  [UserTypes.Visitor]: {
    invite: 'visitorAdded',
    update: 'visitorPermissionUpdated',
    remove: 'visitorRemoved',
  },
};

export const UserEventContexts = {
  [UserTypes.Contributor]: 'Dashpivot Contributor',
  [UserTypes.Visitor]: 'Dashpivot Visitor',
};

export const LearnMoreLinks = {
  [UserTypes.Contributor]: 'https://intercom.help/dashpivot/en/articles/6761343-dashpivot-contributors',
  [UserTypes.Visitor]: 'https://intercom.help/dashpivot/en/articles/6761341-dashpivot-visitors',
};

export function VisitorNotPermittedMessages(planType: CompanyPlanTypes) {
  return `Visitor users are not included on the ${upperFirst(planType)} Plan:`;
}

export function VisitorsAllowedInPlan(billing: CompanyBilling) {
  const isLegacyPlan = billing?.planType === CompanyPlanTypes.Legacy;
  const visitorsAllowedInPlan = Boolean(
    PlanTypeLimits[DashpivotModules.Users].Dashpivot.visitor[billing.planType],
  );

  return isLegacyPlan ? !billing?.legacyRestrictions : visitorsAllowedInPlan;
}
